"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.modes = exports.prepareTransaction = void 0;
var eip55_1 = __importDefault(require("eip55"));
var ethereumjs_abi_1 = __importDefault(require("ethereumjs-abi"));
var invariant_1 = __importDefault(require("invariant"));
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var errors_1 = require("@ledgerhq/errors");
var transaction_1 = require("../transaction");
var Ethereum_1 = require("../../../api/Ethereum");
var NotOwnedNft = (0, errors_1.createCustomErrorClass)("NotOwnedNft");
function prepareTransaction(account, transaction) {
    var _a, _b, _c;
    return __awaiter(this, void 0, void 0, function () {
        var t, collection, collectionName, tokenIds, api, _d, _e, status_1, result, collectionName_1;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    t = transaction;
                    collection = transaction.collection, collectionName = transaction.collectionName, tokenIds = transaction.tokenIds;
                    if (!(collection && tokenIds && typeof collectionName === "undefined")) return [3 /*break*/, 2];
                    api = (0, Ethereum_1.apiForCurrency)(account.currency);
                    return [4 /*yield*/, api.getNFTCollectionMetadata([
                            {
                                contract: collection
                            },
                        ], ((_c = (_b = (_a = account.currency) === null || _a === void 0 ? void 0 : _a.ethereumLikeInfo) === null || _b === void 0 ? void 0 : _b.chainId) === null || _c === void 0 ? void 0 : _c.toString()) || "1")];
                case 1:
                    _d = __read.apply(void 0, [_f.sent(), 1]), _e = _d[0], status_1 = _e.status, result = _e.result;
                    collectionName_1 = "";
                    if (status_1 === 200) {
                        collectionName_1 = (result === null || result === void 0 ? void 0 : result.tokenName) || "";
                    }
                    t = __assign(__assign({}, t), { collectionName: collectionName_1 });
                    _f.label = 2;
                case 2: return [2 /*return*/, Promise.resolve(t)];
            }
        });
    });
}
exports.prepareTransaction = prepareTransaction;
var erc721Transfer = {
    /**
     * Tx data is filled during the buildEthereumTx
     */
    fillTransactionData: function (a, t, tx) {
        var data = serializeTransactionData(a, t);
        (0, invariant_1["default"])(data, "serializeTransactionData provided no data");
        tx.data = "0x" + data.toString("hex");
        tx.to = t.collection;
        tx.value = "0x00";
    },
    /**
     * Tx status is filled after the buildEthereumTx
     */
    fillTransactionStatus: function (a, t, result) {
        var _a, _b;
        (0, transaction_1.validateRecipient)(a.currency, t.recipient, result);
        if (!result.errors.recipient) {
            result.totalSpent = result.estimatedFees;
            result.amount = new bignumber_js_1["default"](t.amount);
            if (result.estimatedFees.gt(a.spendableBalance)) {
                result.errors.amount = new errors_1.NotEnoughBalanceInParentAccount();
            }
            if (!((_b = (_a = a.nfts) === null || _a === void 0 ? void 0 : _a.find) === null || _b === void 0 ? void 0 : _b.call(_a, function (n) { var _a; return n.tokenId === ((_a = t.tokenIds) === null || _a === void 0 ? void 0 : _a[0]) && n.contract === t.collection; }))) {
                result.errors.amount = new NotOwnedNft();
            }
        }
    },
    prepareTransaction: prepareTransaction,
    /**
     * This will only be used by LLM & LLD, not the HW.
     */
    fillDeviceTransactionConfig: function (input, fields) {
        var _a, _b, _c, _d;
        fields.push({
            type: "text",
            label: "Type",
            value: "NFT Transfer"
        });
        fields.push({
            type: "text",
            label: "To",
            value: (_a = input.transaction.recipient) !== null && _a !== void 0 ? _a : ""
        });
        fields.push({
            type: "text",
            label: "Collection Name",
            value: input.transaction.collectionName || ""
        });
        fields.push({
            type: "address",
            label: "NFT Address",
            address: (_b = input.transaction.collection) !== null && _b !== void 0 ? _b : ""
        });
        fields.push({
            type: "text",
            label: "NFT ID",
            value: (_d = (_c = input.transaction.tokenIds) === null || _c === void 0 ? void 0 : _c[0]) !== null && _d !== void 0 ? _d : ""
        });
    },
    /**
     * Optimistic Operation is filled post signing
     */
    fillOptimisticOperation: function (a, t, op) {
        op.type = "FEES";
    },
    getResolutionConfig: function () { return ({ nft: true }); }
};
function serializeTransactionData(account, transaction) {
    var _a;
    var from = eip55_1["default"].encode(account.freshAddress);
    var to = eip55_1["default"].encode(transaction.recipient);
    return ethereumjs_abi_1["default"].simpleEncode("safeTransferFrom(address,address,uint256,bytes)", from, to, (_a = transaction.tokenIds) === null || _a === void 0 ? void 0 : _a[0], "0x00");
}
exports.modes = {
    "erc721.transfer": erc721Transfer
};
//# sourceMappingURL=erc721.js.map